var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.12,
    height: 107.309,
    viewBox: "0 0 191.12 107.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5396",
    "data-name": "Group 5396",
    transform: "translate(-387.863 -492.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33102",
    "data-name": "Path 33102",
    d: "M465.467,609.085h5.419a14.7,14.7,0,0,0,13.607-9.1c2.257-5.5,5.373-12.178,8.543-16.13,2.986-3.722,5.228-9.734,6.738-14.892a7.637,7.637,0,0,0-7.324-9.792H477.969l-15.815,37.294Z",
    transform: "translate(-53.828 -33.529)",
    fill: "#b0b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33103",
    "data-name": "Path 33103",
    d: "M656.535,626.928c0,9.915-14.533,23.918-65.654,30.329-31.058,3.9-73.014-13.706-80.9-21.6-7.007-7.015,49.6-27.587,80.9-27.587S656.535,617.013,656.535,626.928Z",
    transform: "translate(-77.552 -58.092)",
    fill: "#c2cefd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5395",
    "data-name": "Group 5395",
    transform: "translate(354.983 492.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5386",
    "data-name": "Group 5386",
    transform: "translate(32.88 27.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33112",
    "data-name": "Path 33112",
    d: "M475.155,560.037a18.776,18.776,0,0,0-13.537-11.365c-8.372-1.808-16.086-2.474-20.121,6.838a58.818,58.818,0,0,0-1.173,5.831,23.52,23.52,0,0,1-8.923,13.075s-7.678,4.734-9.051,8.12c-2.841,7.007-1.155,11.072,6.054,16.5,1.569,1.182,6.359,2.486,8.333,3.053,7.546,2.167,13.235.884,15.473-.362,6.4-3.565,8.026-7.555,11.217-14.405C463.426,587.325,477.761,566.6,475.155,560.037Z",
    transform: "translate(-421.042 -547.571)",
    fill: "#bdc4d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33113",
    "data-name": "Path 33113",
    d: "M477.867,568.487a21.3,21.3,0,0,0-2.471-4.527c.428,1.143,2.124,5.146,1.613,7.444-1.531,6.891-12.583,22.78-12.583,22.78-3.191,6.851-3.963,9.972-10.363,13.537-2.237,1.246-10.847,1.212-18.393-.955-1.974-.567-6.763-1.87-8.332-3.053-.242-.182-.476-.365-.706-.547a29.877,29.877,0,0,0,4.579,4.107c1.569,1.182,6.359,2.486,8.333,3.053,7.546,2.167,13.235.883,15.473-.362,6.4-3.565,8.026-7.555,11.217-14.405a240.938,240.938,0,0,0,11.793-22.584C480.59,567.064,478.8,570.844,477.867,568.487Z",
    transform: "translate(-423.85 -555.802)",
    fill: "#b0b9c9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33116",
    "data-name": "Path 33116",
    d: "M627.621,537.405c-1.11-2.691-4.342-7.181-8.248-8.5-4.258-1.442-10.494-1.3-14.233.406-3.3,1.5-8.191,6.756-9.108,7.877-.428.522,7.133-.656,7.133-.656l-.063.191-.059.179c-3.166,9.562-13.846,20.106-23.607,17.62-13.638-3.474-32.87-6.119-43.774-6.378-5.491-.13-11.475.029-13.181,3.214a9.079,9.079,0,0,0-.787,3.164c-1.057,9.945-7.047,18.731-13.188,26.546-.131.167-.8.752-1.071.99l-.066.058a10.388,10.388,0,0,0-3.5,8.241c0,7.655,2.907,9.379,12.027,12.748,6.051,2.235,26.637,11.162,41.911,13.46,26.454,3.981,46.886-3.892,62.035-25.941a49.746,49.746,0,0,0,3.63-6.092C632.474,566.138,631.265,546.243,627.621,537.405Z",
    transform: "translate(-429.761 -510.244)",
    fill: "#bdc4d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33117",
    "data-name": "Path 33117",
    d: "M619.86,649.907c.992-1.444,1.818-2.776,2.489-3.952-.213.274-21.051,27.076-44.682,26.122-21.848-.881-66.707-18.616-73.76-21.454.254,6.823,3.294,8.545,12.007,11.764,6.051,2.235,26.637,11.162,41.911,13.46C584.279,679.829,604.711,671.955,619.86,649.907Z",
    transform: "translate(-429.782 -569.53)",
    fill: "#b0b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33118",
    "data-name": "Path 33118",
    d: "M601.227,538.907,573.344,561c-3.378-.6-9.5-1.689-11.674-2.08-3.065-.55-24.042-3.744-29.691-4.061a10.072,10.072,0,0,0-3.974,1.145q-.075.456-.128.956a32.493,32.493,0,0,1-4.685,12.99c-2.369,5.161-6.525,10.988-10.006,15.48,1.593-1.468,3.517-.9,4.881-.685,10.73,2.411,39.291,16.732,48.639,16.552,10.57-.2,20.345-11.132,30.529-26.8,4.212-6.481,12.776-18.056,14.405-22.251C620.885,528.448,601.227,538.907,601.227,538.907Z",
    transform: "translate(-434.443 -514.615)",
    fill: "#bdc4d2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5387",
    "data-name": "Group 5387",
    transform: "translate(42.59 28.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33119",
    "data-name": "Path 33119",
    d: "M465.772,561.67s-7.094-3.08-8.14-4.345a17.924,17.924,0,0,1-2.855-5.816c-.66-2.255-5.216-1.554-4.043,2.9.194.736,1.288,2.318,1.782,3.99a11.632,11.632,0,0,1,.308,4.259,3.473,3.473,0,0,0,2.717,4.018c2.255.55,8.415.825,10.12,1.21S465.772,561.67,465.772,561.67Z",
    transform: "translate(-445.569 -550.261)",
    fill: "#272a37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33120",
    "data-name": "Path 33120",
    d: "M454.255,584.009s-5.811-3.245-6.855-4.51-2.635-3.466-2.635-5.816c0-3.094-5.216-1.553-4.043,2.9.194.735.758,2.385,1.252,4.058a14.883,14.883,0,0,1,.838,4.192,3.19,3.19,0,0,0,2.755,3.688c2.255.55,8.414.825,10.119,1.21S454.255,584.009,454.255,584.009Z",
    transform: "translate(-440.55 -561.211)",
    fill: "#272a37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33121",
    "data-name": "Path 33121",
    d: "M557.249,585.319l-23.882-5.1-35.83-8.451-28.4-3.562-.564,0c-1.056-.187-2.06,1.417-3.169,3.307-1.245,2.123-.863,4.331.161,4.932a1.1,1.1,0,0,0,.312.117l0,0,26.387,5.815c3.831,1.022,23.594,7.7,45.82,16.4A42.131,42.131,0,0,0,553.406,602a99.8,99.8,0,0,0,15.6-11.807Z",
    transform: "translate(-452.641 -559.266)",
    fill: "#373162"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33122",
    "data-name": "Path 33122",
    d: "M553.409,605.222A42.128,42.128,0,0,1,538.087,602c-22.226-8.7-41.989-15.382-45.82-16.4l-26.387-5.815,0-.005a1.1,1.1,0,0,1-.312-.116,2.02,2.02,0,0,1-.837-1.3c-.306,1.478.1,2.756.837,3.191a1.1,1.1,0,0,0,.312.117l0,0,26.387,5.815c3.831,1.022,23.594,7.7,45.82,16.4a42.131,42.131,0,0,0,15.322,3.219,99.834,99.834,0,0,0,15.6-11.807l-1.407-.583A106.657,106.657,0,0,1,553.409,605.222Z",
    transform: "translate(-452.645 -564.374)",
    fill: "#26214a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33123",
    "data-name": "Path 33123",
    d: "M546.043,612.991l-28.608-8.447-30.394-7.927-26.873-4.906-1.105-.229c-1.046-.237-2.174.992-3.371,2.828-1.345,2.062-1.629,4.258-.635,4.907a1.1,1.1,0,0,0,.307.131l0,0,25.178,7.989c3.989,1.249,23.934,8.44,45.722,18.189a49.43,49.43,0,0,0,8.244,2.894,15.464,15.464,0,0,0,11.866-1.9c3.908-2.423,5.539-6.631,8.981-9.655Z",
    transform: "translate(-447.538 -570.95)",
    fill: "#373162"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33124",
    "data-name": "Path 33124",
    d: "M546.627,630.263a15.465,15.465,0,0,1-11.866,1.9,49.478,49.478,0,0,1-8.244-2.895c-21.788-9.749-41.734-16.94-45.722-18.189L455.616,603.1l0-.005a1.07,1.07,0,0,1-.306-.131,1.966,1.966,0,0,1-.544-2.02c-.475,1.386-.4,2.59.288,3.042a1.1,1.1,0,0,0,.307.131l0,0,25.178,7.989c3.989,1.249,23.934,8.44,45.722,18.189a49.421,49.421,0,0,0,8.244,2.894,15.464,15.464,0,0,0,11.866-1.9c3.908-2.424,5.539-6.631,8.981-9.655l-.569-.237C551.881,624.326,550.207,628.042,546.627,630.263Z",
    transform: "translate(-447.539 -575.714)",
    fill: "#26214a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5390",
    "data-name": "Group 5390",
    transform: "translate(86.73 15.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33125",
    "data-name": "Path 33125",
    d: "M641.725,575.078s6.754-9.9,9.729-19.233c1.581-4.959,1.277-7.279-.492-13.956a4.9,4.9,0,0,0-3.4-3.8,12.105,12.105,0,0,0-3.043-.315c-10.7.179-10.69,5.111-11.922,7.555s-12.26,16.822-15.516,21.646c-1.144,1.694-6.226-.7-9.674,3.543-4.472,5.5-6.537,10.7-5.275,12.245,1.34,1.639,1.978,5.694,2.217,8.088s1,4.988,2.714,6.19c1.272.893,5.789-.353,5.789-.353l-1.392,3.043s1.724,1.085,8.114.308C629.574,593.928,634.994,587.1,641.725,575.078Z",
    transform: "translate(-565.661 -530.427)",
    fill: "#ffd102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33126",
    "data-name": "Path 33126",
    d: "M630.057,594.739c-.405.6-1.306.688-2.452.739,1.049,2.4,3.778,7.957,3.778,7.957-.884-3.12-1.14-7.979-.151-10.384C630.777,593.692,630.378,594.264,630.057,594.739Z",
    transform: "translate(-578.64 -558.191)",
    fill: "#ffac19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33127",
    "data-name": "Path 33127",
    d: "M570.531,603.427l-22.175-7.676a2.318,2.318,0,0,1-1.479-2.8l7.406-27.154a.944.944,0,0,1,1.219-.643l23.268,7.119c1.225,1.257.867,2.083.628,3.107l-6.2,26.573A2.054,2.054,0,0,1,570.531,603.427Z",
    transform: "translate(-538.052 -544.152)",
    fill: "#a8b7d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33128",
    "data-name": "Path 33128",
    d: "M570.531,601.15l-22.175-7.676a2.318,2.318,0,0,1-1.479-2.8l7.406-27.154a.944.944,0,0,1,1.219-.643L578.07,570.7A2.053,2.053,0,0,1,579.4,573.1l-6.2,26.573A2.054,2.054,0,0,1,570.531,601.15Z",
    transform: "translate(-538.052 -543.009)",
    fill: "#ebe6f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33129",
    "data-name": "Path 33129",
    d: "M558.886,569.831l-6.143,22.919a1.06,1.06,0,0,0,.677,1.276l15.315,5.3a1.08,1.08,0,0,0,1.405-.774l5.435-23.158a1.06,1.06,0,0,0-.685-1.244l-14.608-5.062A1.081,1.081,0,0,0,558.886,569.831Z",
    transform: "translate(-541.022 -546.126)",
    fill: "#a8b7d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33130",
    "data-name": "Path 33130",
    d: "M595.383,597.091l-2.276,8.51L597.9,607.2l2.229-8.5Z",
    transform: "translate(-561.313 -560.22)",
    fill: "#1b0e2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5388",
    "data-name": "Group 5388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33131",
    "data-name": "Path 33131",
    d: "M535.608,523.788l-6.276,26.917a3.924,3.924,0,0,0,.114,2.177L536.1,572.1c.237.71,1.656.689,1.809.129l7.057-28.546-7.048-20.007C537.5,522.58,535.791,523,535.608,523.788Z",
    transform: "translate(-529.23 -523.014)",
    fill: "#a8b7d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33132",
    "data-name": "Path 33132",
    d: "M537.126,523.932l-6.276,26.917a3.924,3.924,0,0,0,.114,2.177l6.658,19.219a.59.59,0,0,0,1.126-.038l7.74-28.379-7.8-20.007A.819.819,0,0,0,537.126,523.932Z",
    transform: "translate(-529.992 -523.157)",
    fill: "#1b0e2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33133",
    "data-name": "Path 33133",
    d: "M532.014,552.675l6.484-27.809c.005-.023.011-.049.064-.049a.049.049,0,0,1,.056.04l7.712,19.774L538.8,572.253Z",
    transform: "translate(-530.628 -523.919)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33134",
    "data-name": "Path 33134",
    d: "M536.987,560.493l4.629-19.853,4.708,12.072-5.3,19.433Z",
    transform: "translate(-533.126 -531.866)",
    fill: "#b9b9b9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33135",
    "data-name": "Path 33135",
    d: "M599.766,584.162l-11.1.766-3.553-1.585s-4.081-1.476-5.932-.934c-1.1.324-1.936,1.977-2.2,2.647s-.18,2.638.671,2.522a9.806,9.806,0,0,1,4.262.511c.5.192-1.82,1.237-.862,1.652a6.749,6.749,0,0,0,2.261.418l3.125-.193a12.319,12.319,0,0,1,2.59.112l9.6.022Z",
    transform: "translate(-553.146 -552.785)",
    fill: "#ffaa83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33136",
    "data-name": "Path 33136",
    d: "M618.888,568.17c.162-.055.323-.1.484-.146l.089-.023a9.428,9.428,0,0,1,.974-.2l.066-.009c.153-.022.306-.042.457-.058l.019,0q.25-.026.493-.043h0c.523-.038,1.022-.053,1.481-.075l.21-.01.173-.01c.1-.006.2-.014.3-.023l.112-.011c.086-.009.17-.019.252-.031l.079-.011q.152-.024.292-.056l.07-.018c.074-.019.144-.041.213-.064l.066-.024a1.737,1.737,0,0,0,.231-.109c.013-.007.024-.016.036-.023a1.3,1.3,0,0,0,.166-.12c.017-.014.033-.029.049-.044a1.109,1.109,0,0,0,.158-.182c3.256-4.824,14.29-19.213,15.516-21.646.994-1.973,2.788-5.751,9.066-7.23-1.5-.424-2.962-.668-3.711-.051l-3.892,2.533c-4.6,2.011-13.34,18.731-13.34,18.731l-9.609,1.979c-1.373.383-.492-.761-1.069,2.69a9.109,9.109,0,0,0,.566,4.286Z",
    transform: "translate(-573.943 -530.329)",
    fill: "#ffd102"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5389",
    "data-name": "Group 5389",
    transform: "translate(46.215 30.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33137",
    "data-name": "Path 33137",
    d: "M622.087,584.565l.56,6.121a1.208,1.208,0,0,1-.1.595l-.115.015c.075-.009.149-.02.223-.028l.019,0c.117-.012.23-.021.344-.03a1.189,1.189,0,0,0,.084-.549l-.56-6.121a1.266,1.266,0,0,0-.026-.131l-.437.09C622.082,584.538,622.086,584.551,622.087,584.565Z",
    transform: "translate(-622.08 -584.434)",
    fill: "#ffac19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33138",
    "data-name": "Path 33138",
    d: "M622.371,598.334l.072-.012Z",
    transform: "translate(-622.226 -591.409)",
    fill: "#509184"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33139",
    "data-name": "Path 33139",
    d: "M617.711,590.851a8.911,8.911,0,0,1,2.322-.557,1.208,1.208,0,0,0,.1-.595l-.56-6.121a1.221,1.221,0,0,0-1.327-1.1l-.507.046a1.221,1.221,0,0,0-1.1,1.327l.56,6.121A1.213,1.213,0,0,0,617.711,590.851Z",
    transform: "translate(-573.127 -552.876)",
    fill: "#ffd102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33140",
    "data-name": "Path 33140",
    d: "M616.634,583.838l.039.424a1.346,1.346,0,0,1,1.181-1.018l.459-.042a1.347,1.347,0,0,1,1.287.667l-.027-.3a1.212,1.212,0,0,0-1.318-1.1l-.524.048A1.211,1.211,0,0,0,616.634,583.838Z",
    transform: "translate(-573.127 -552.875)",
    fill: "#ffac19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33141",
    "data-name": "Path 33141",
    d: "M675.641,546.32s-5.481,2.25-5.938,5.045c-.247,1.512,1.022,2.618,3.959,2.618s7.813-.158,9.45-1.852c1.852-1.915,1.645-4.374.806-5.3C682.945,545.757,677.684,545.235,675.641,546.32Z",
    transform: "translate(-513.039 -519.187)",
    fill: "#ffaa83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5391",
    "data-name": "Group 5391",
    transform: "translate(149.45 67.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33142",
    "data-name": "Path 33142",
    d: "M655.241,627.455v0Z",
    transform: "translate(-655.241 -627.455)",
    fill: "#4566ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5392",
    "data-name": "Group 5392",
    transform: "translate(128.822 39.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33143",
    "data-name": "Path 33143",
    d: "M650.48,572.16c-2.06-1.424-5.433-1.47-9.977-.409l-.987.87a45.74,45.74,0,0,0-10.7,13.793q-.8,1.6-1.5,3.25l-2,4.718-7.078-.808c-1.006-.181-2.586,1.923-3.162,5.375-.313,1.878-1.965,2.693-.959,2.874l9.886,4.6c2.278.891,5.4,1.3,9.3-2.6l18.07-21.773C654.12,578.226,652.539,573.583,650.48,572.16Z",
    transform: "translate(-613.797 -571.015)",
    fill: "#ffac19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5393",
    "data-name": "Group 5393",
    transform: "translate(129.917 37.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33144",
    "data-name": "Path 33144",
    d: "M651.491,569.43c-2.06-1.424-7.1-1.985-10.675,1.709l-3.776,4.7a56.44,56.44,0,0,0-7.967,13.317l-2,4.718-7.73-2.062c-1.006-.182-2.678.957-3.254,4.409-.313,1.878.2,4.278,1.211,4.459l7.717,3.019c2.278.89,5.4,1.3,9.3-2.6l18.07-21.774C655.13,575.5,653.55,570.854,651.491,569.43Z",
    transform: "translate(-615.996 -568.34)",
    fill: "#ffd102"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33145",
    "data-name": "Path 33145",
    d: "M580.161,602.857a22.563,22.563,0,0,1-3.336-2.06c-1.254-.428-1.261.431-1.261.431a5.039,5.039,0,0,1-1.535-.177l-4.449-1.654a.567.567,0,0,0-.395,1.062l2.834,1.054a8.027,8.027,0,0,0-.478.705,3.808,3.808,0,0,0-.31,2.3,2.875,2.875,0,0,0,3.184,2.417,10.33,10.33,0,0,1,4.141.948l-.053.166,15.415,7.56,2.231-7.353Z",
    transform: "translate(-462.383 -546.128)",
    fill: "#ffaa83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33146",
    "data-name": "Path 33146",
    d: "M618.677,613.678a1.907,1.907,0,0,0-1.79-.673,2.239,2.239,0,0,0-1.135.537.918.918,0,0,0-.225.277l-3.405,7.386a1.615,1.615,0,0,0,.79,2.143l.612.282a1.614,1.614,0,0,0,2.143-.79l3.406-7.386.006-.013A1.59,1.59,0,0,0,618.677,613.678Z",
    transform: "translate(-484.058 -552.966)",
    fill: "#ffd102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33147",
    "data-name": "Path 33147",
    d: "M615.657,630.8l.236-.511a1.78,1.78,0,0,1-2.027.386l-.554-.255a1.783,1.783,0,0,1-1.033-1.616l-.167.361a1.6,1.6,0,0,0,.785,2.128l.633.292A1.6,1.6,0,0,0,615.657,630.8Z",
    transform: "translate(-484.054 -560.916)",
    fill: "#ffac19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5394",
    "data-name": "Group 5394",
    transform: "translate(149.516 3.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33148",
    "data-name": "Path 33148",
    d: "M687.082,531.924a34.765,34.765,0,0,1-9.4,2.544v7.956h0c.044,1.749,1.363,2.5,2.969,3.193a9.192,9.192,0,0,0,3.448.319,4.368,4.368,0,0,0,2.7-1.947,4.764,4.764,0,0,0,.8-2.893C687.522,538.889,687.312,533.93,687.082,531.924Z",
    transform: "translate(-666.58 -515.875)",
    fill: "#ffaa83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33149",
    "data-name": "Path 33149",
    d: "M684.942,539.324a5.2,5.2,0,0,0,2.5-1.573c-.069-1.423-.145-2.776-.234-3.949a5.6,5.6,0,0,0-.61-.745c-.019,0-.311-.03-.757-.077a35.879,35.879,0,0,1-8.15,2.017v6.36l5.044-1.876A7.993,7.993,0,0,0,684.942,539.324Z",
    transform: "translate(-666.58 -516.406)",
    fill: "#ef8f6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33150",
    "data-name": "Path 33150",
    d: "M676.456,514.053c1.511-4.912,2.267-9.445,0-11.712-1.722-1.722-8.336-3.031-14.4-2.567a7.231,7.231,0,0,0-6.679,7.507c.044.966.541,2.437.753,3.661-.713,3.088.418,8.08.961,9.365a3.627,3.627,0,0,0,2.852,2.454,11.823,11.823,0,0,0,4.783-.124l6.538-2.362a44.945,44.945,0,0,1,4.61-2.219C675.68,516.354,675.86,515.988,676.456,514.053Z",
    transform: "translate(-655.372 -499.68)",
    fill: "#ffaa83"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33151",
    "data-name": "Path 33151",
    d: "M652.982,503.152c1.6,1.054,2.233,1.076,4.1.688,1.259-.261,2.647-.412,2.85.127.383,1.016.188,5.334.092,6.291h1.328s.828-1.678,1.569-2.958c1.041-1.8,4.091-.668,3.8,1.388-.074.529-2.419,2.7-2.294,3.5.325,2.074,3.863,3.561,5.312,4.527.757.5,3.5-.905,4.406-1.63a5.446,5.446,0,0,0,1.569-2.483,39.882,39.882,0,0,0,1.2-4.482c.537-2.746,2.682-4.789,1.341-7.982s-1.341-3.065-3.065-4.022-3.64-2.813-5.619-3.32a15.587,15.587,0,0,0-5.744-.214,25.916,25.916,0,0,1-4.182.607,8.162,8.162,0,0,0-4.042.913c-1.086.706-2.923.775-3.4,1.925s-1.859,4.347-.518,6.007A5.665,5.665,0,0,0,652.982,503.152Z",
    transform: "translate(-503.725 -492.412)",
    fill: "#272a37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenShop);
export default __webpack_public_path__ + "static/media/open-shop.d1519ed7009f73fbe47bcf7a84341535.svg";
export { ForwardRef as ReactComponent };